import { useCallback, useEffect, useRef, useState } from "react";

export type ChangedCells = { [key: number]: Set<string> };

const useChangedCells = () => {
  const [changedCells, setChangedCells] = useState<ChangedCells>({});
  const changedCellsRef = useRef<ChangedCells>({});

  useEffect(() => {
    changedCellsRef.current = changedCells;
  }, [changedCells]);

  const markCellChanged = useCallback((rowId: number, field?: string) => {
    if (!field) return;

    const newChanges = { ...changedCellsRef.current };
    newChanges[rowId] = new Set(newChanges[rowId] || []);
    newChanges[rowId].add(field);
    changedCellsRef.current = newChanges;
    setChangedCells(newChanges);
  }, []);

  const resetChangedCells = useCallback(() => {
    changedCellsRef.current = {};
    setChangedCells({});
  }, []);

  return {
    changedCells,
    changedCellsRef,
    markCellChanged,
    resetChangedCells,
    setChangedCells,
  };
};

export default useChangedCells;
